<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <!-- Search Component -->

    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openSideDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            dense
            class="flex-60 pt-xs"
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>build</mat-icon>
        </td>
      </ng-container>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.id' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">{{ plan.id }}</td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">{{ plan.name }}</td>
      </ng-container>

      <!-- createdAt -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.createdAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">
          {{ plan.createdAt | date: 'short' }}
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
